export function unwrapPagedCollections(value) {
  const typeString = Object.prototype.toString.call(value);
  if (typeString === '[object Object]') {
    if (value.edges) {
      return value.edges.map((edge) => unwrapPagedCollections(edge.node));
    } else {
      return Object.fromEntries(
        Object.entries(value).map(([k, v]) => [k, unwrapPagedCollections(v)])
      );
    }
  } else if (typeString === '[object Array]') {
    return value.map(unwrapPagedCollections);
  } else {
    return value;
  }
}

export function modifyCollectionManually(setState, collectionName, collectionModifier) {
  setState((prevState) => {
    const updatedCollection = {};
    updatedCollection[collectionName] = collectionModifier(prevState[collectionName]);
    return {
      ...prevState,
      ...updatedCollection,
    };
  });
}

export function addToCollectionManually(setState, collectionName, node, comparator) {
  modifyCollectionManually(setState, collectionName, (collection) =>
    [unwrapPagedCollections(node), ...collection].sort(comparator)
  );
}
export function removeFromCollectionManually(setState, collectionName, nodeId) {
  modifyCollectionManually(setState, collectionName, (collection) =>
    collection.filter((node) => node.id !== nodeId)
  );
}
